// 9fbef606107a605d69c0edbcd8029e5d

export default {
  CAROUSEL_OPTIONS: {
    autoplay: false,
    arrows: true,
    speed: 200,
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: false,
  },
  CAROUSEL_OPTIONS_ADDED_TO_BAG: {
    autoplay: false,
    arrows: true,
    speed: 200,
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false,
  },
  params: {
    moduleO: {
      dataLocator: 'moduleO_header_text',
    },
    moduleP: {
      dataLocator: 'moduleP_header_text',
    },
    ATBmodal: {
      dataLocator: 'moduleP_header_text',
    },
    styleWith: {
      dataLocator: 'styleWith_header_text',
    },
  },
  variations: {
    moduleO: 'moduleO',
    moduleP: 'moduleP',
    ATBmodal: 'ATBmodal',
    styleWith: 'styleWith',
  },
};
